export enum RegisterFormControls {
    PASSWORD = 'password',
    PASSWORD_REPEAT = 'passwordRepeat'
}
